import { ChevronLeft, ChevronRight, ZoomIn, ZoomOut } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";


export const ModuleReaderToolbar = ({
  pageCount,
  pageInput,
  onPageInputChange,
  onPageInputSubmit,
  pageInputError,
  onPrevious,
  onNext,
  previousDisabled,
  nextDisabled,
  pageLoading,
  zoomLabel,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  canZoomIn,
  canZoomOut,
}) => (
  <div className="rounded-[1.15rem] border border-[#f1b963] bg-[#fcfaf5]/95 p-3 backdrop-blur sm:p-3.5" data-testid="module-reader-toolbar">
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      <div className="min-w-0 space-y-2 lg:flex-none">
        <div className="flex flex-wrap items-center gap-2.5">
          <label htmlFor="module-reader-page-input" className="text-[0.72rem] font-semibold uppercase tracking-[0.22em] text-slate-500 whitespace-nowrap">Go to page</label>
          <Input id="module-reader-page-input" inputMode="numeric" pattern="[0-9]*" value={pageInput} onChange={(event) => onPageInputChange(event.target.value)} className="h-10 w-[5.25rem] rounded-full border-[#f1b963] bg-white text-center text-sm shadow-none focus-visible:ring-[#f5a623]" data-testid="module-reader-page-input" />
          <span className="text-sm text-slate-600">of {pageCount}</span>
          <Button type="button" variant="outline" className="h-10 rounded-full border-[#f1b963] bg-white px-4 text-slate-900 hover:bg-[#fff3de] hover:text-slate-950" onClick={onPageInputSubmit} data-testid="module-reader-go-to-page-button">
            Go
          </Button>
        </div>
        {pageInputError ? <p className="text-sm text-red-700" data-testid="module-reader-page-input-error">{pageInputError}</p> : null}
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-3 lg:items-center">
        <div className="flex flex-wrap items-center gap-2 lg:justify-center">
          <span className="text-[0.72rem] font-semibold uppercase tracking-[0.22em] text-slate-500" data-testid="module-reader-toolbar-status">
            {pageLoading ? "Loading page" : zoomLabel}
          </span>
          <Button type="button" variant="outline" className="h-10 rounded-full border-[#f1b963] bg-white px-4 text-slate-900 hover:bg-[#fff3de] hover:text-slate-950" onClick={onZoomOut} disabled={!canZoomOut} data-testid="module-reader-zoom-out-button">
            <ZoomOut className="h-4 w-4" />
            Zoom out
          </Button>
          <Button type="button" variant="outline" className="h-10 rounded-full border-[#f1b963] bg-white px-4 text-slate-900 hover:bg-[#fff3de] hover:text-slate-950" onClick={onResetZoom} data-testid="module-reader-fit-width-button">
            Fit width
          </Button>
          <Button type="button" variant="outline" className="h-10 rounded-full border-[#f1b963] bg-white px-4 text-slate-900 hover:bg-[#fff3de] hover:text-slate-950" onClick={onZoomIn} disabled={!canZoomIn} data-testid="module-reader-zoom-in-button">
            <ZoomIn className="h-4 w-4" />
            Zoom in
          </Button>
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-2 lg:flex-none lg:justify-end">
        <Button type="button" variant="outline" className="h-10 rounded-full border-[#f1b963] bg-white px-4 text-slate-900 hover:bg-[#fff3de] hover:text-slate-950" onClick={onPrevious} disabled={previousDisabled} data-testid="module-reader-previous-page-button">
          <ChevronLeft className="h-4 w-4" />
          Previous
        </Button>
        <Button type="button" className="h-10 rounded-full border border-[#f1b963] bg-[#fff3de] px-4 text-slate-950 shadow-none hover:bg-[#ffe7bb]" onClick={onNext} disabled={nextDisabled} data-testid="module-reader-next-page-button">
          Next
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  </div>
);
